<template>
  <div v-html="agreementContent" ></div>
</template>
<style lang="scss">
.title {
  text-align: center;
  font-weight: bold;
}
p {
  line-height: 2em;
}
</style>
<script>

export default{
  data() {
    return {
      agreementContent:""
    };
  },
  methods: {
    loadAgreement(){
      const axios = require('axios').default;
      axios.get("/agreement/" + location.hostname + ".html")
        .then((response) =>{
          this.agreementContent = response.data;
        })
        .catch((error) =>{
          axios.get("/agreement/default.html")
          .then((response) =>{
            this.agreementContent = response.data;
          });
        })
    }
  },
  created() {
    this.loadAgreement();
  }
}

</script>
